import React, { useEffect, useState } from 'react';


const TOPBAR_HEIGHT = 56;
const ZealogicsApp = () => {
    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            margin: 0,
            padding: 0,
            overflow: 'hidden'
        }}>
            {/* Top bar placeholder */}
            <div style={{
                width: '100vw',
                height: `${TOPBAR_HEIGHT}px`,
                background: '#fff', // or your preferred color
                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 24,
                fontWeight: 600,
                fontSize: 18
            }}>
                Zealogics App
            </div>
            <iframe
                src="https://zealogics.zeasale.com"
                title="Zealogics App"
                style={{
                    width: '100vw',
                    height: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
                    border: 'none',
                    display: 'block'
                }}
            />
        </div>
    );
}
export default ZealogicsApp;